<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2>
        <h1 class="primary--text mb-4">Create Location</h1>
        <app-alert class="mb-3" type="error" :message="error" @dismissed="error = false"/>

        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">
            <span>Location Details</span>
            <v-spacer></v-spacer>
            <v-icon @click="$router.go(-1)">close</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-form ref="form" @submit.prevent="doCreateLocation">
            <v-container class="px-4">
              <v-layout justify-space-between row wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Name"
                    type="text"
                    v-model="location.name"
                    :rules="[rules.isRequired]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Type"
                    v-model="location.type"
                    :items="typeOptions"
                    :rules="[rules.isRequired]"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-autocomplete
                    label="State"
                    v-model="location.state_id"
                    @change="loadAreaOptions"
                    :items="stateOptions"
                    :rules="[rules.isRequired]"
                    :loading="statesLoading"
                    :disabled="statesLoading"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Local Government"
                    v-model="location.tag"
                    :items="areaOptions"
                    :rules="[rules.isRequired]"
                    :loading="areasLoading"
                    :disabled="!areaOptions.length"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <div class="v-input v-text-field theme--light primary--text mt-0 pt-0">
                    <div class="v-input__control">
                      <div class="v-input__slot">
                        <div class="v-text-field__slot">
                          <gmap-autocomplete
                            class="input-location"
                            name="location"
                            placeholder="Search map location"
                            @input="addressRequired = true"
                            @place_changed="setAddress"
                            autocomplete="off"
                            required
                          ></gmap-autocomplete>
                        </div>
                      </div>
                      <div class="v-text-field__details" v-if="addressRequired && !isAddressValid">
                        <div class="v-messages theme--light error--text">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">Map address is required</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout class="mt-3 mb-3">
                <v-btn depressed color="accent" type="submit" :disabled="isSaving">
                  Create
                  <v-progress-circular
                    class="ml-2"
                    :indeterminate="true"
                    :size="18"
                    :width="2"
                    v-if="isSaving"
                  ></v-progress-circular>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn depressed @click="$router.go(-1)">Cancel</v-btn>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import '@/plugins/google-maps'
import { mapGetters } from 'vuex'

import { LOCATION_CREATE } from '@/store/actions/location'
import { STATE_FETCH } from '@/store/actions/state'
import { statusOptions } from '@/data/options'

export default {
  name: 'CreateLocation',
  created () {
    this.statesLoading = true
    this.$store.dispatch(STATE_FETCH)
      .finally(_ => (this.statesLoading = false))
  },
  data () {
    return {
      location: {
        name: '',
        status: 'active',
        type: '',
        address: '',
        tag: '',
        latitude: '',
        longitude: '',
        population: 0,
        state_id: '',
        country_id: this.$settings.country
      },
      areasLoading: false,
      areaOptions: [],
      isSaving: false,
      statesLoading: false,
      statusOptions: statusOptions,
      typeOptions: [
        { text: 'Camp', value: 'camp' },
        { text: 'Community', value: 'community' }
      ],
      addressRequired: false,
      error: false,
      rules: {
        isRequired: value => this.$validator.isRequired(value)
      }
    }
  },
  computed: {
    stateOptions () {
      let stateOptions = this.$store.getters.statesAsOptions
      // If state agent, show only agents state in list
      if (this.currentUser.parent && this.currentUser.parent === 'state') {
        const state = stateOptions.find(stateOption => this.currentUser.parent_id === stateOption.value)
        stateOptions = [state]
      }
      return stateOptions
    },
    isAddressValid () {
      return this.location.address.trim() !== ''
    },
    ...mapGetters({
      currentUser: 'currentUser'
    })
  },
  methods: {
    setAddress (place) {
      this.addressRequired = !this.isAddressValid
      this.location.address = place.formatted_address
      this.location.latitude = place.geometry.location.lat()
      this.location.longitude = place.geometry.location.lng()
    },
    loadAreaOptions () {
      this.areasLoading = true
      const stateName = this.$store.getters.stateName(this.location.state_id)
      if (stateName !== '') {
        //this.$http.get(`https://locationsng-api.herokuapp.com/api/v1/states/${stateName}/lgas`)
        this.$http.get(`https://api.csv49.xyz/csv8/state/${stateName}`)
          .then((response) => {
            const data = response.data.data

            this.areasLoading = false
            this.areaOptions = !data.length ? [] : data.map(lga => ({ text: lga, value: lga }))
          })
      }
    },
    doCreateLocation () {
      this.addressRequired = !this.isAddressValid
      if (!this.$refs.form.validate() || !this.isAddressValid) return
      this.isSaving = true
      this.$store.dispatch(LOCATION_CREATE, this.location)
        .then(() => this.$router.push('/locations?locationCreated=1'))
        .catch(error => (this.error = error.message))
        .finally(() => (this.isSaving = false))
    }
  }
}
</script>

<style scoped>
.input-location {
  display: block;
  margin: 0 auto;
  margin-top: 20px;
  outline: none;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
}
</style>
